import { stateProperty, State } from "@dodona/lit-state";

class EvaluationState extends State {
    @stateProperty public id: number;
}

export const evaluationState = new EvaluationState();
